import { UNAUTH_USER, USER_DATA_SUCCESS, AUTH_USER } from '../actions/types';
import {
  localStorageAuthToken,
  localStorageAuthTokenExpiry,
  localStorageIsChild,
  LS_EMAIL,
  localStorageProfileName,
  localStorageProfileId,
} from '../constants';
import { resetSessionID } from '../mys4c_helpers';

const persist = (store) => (next) => (action) => {
  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 20);

  let result = next(action);
  switch (action.type) {
    case AUTH_USER:
      // Note there is no resetSessionID() here, on purpose. The analytics session
      // id has to survive sign in - that is what lets the backend attribute a
      // user's anonymous activity to their account. Adding a reset here for
      // symmetry with UNAUTH_USER would silently break that.
      localStorage.removeItem(localStorageAuthToken);
      localStorage.removeItem(localStorageAuthTokenExpiry);
      let token = action.payload;
      localStorage.setItem(localStorageAuthToken, token);
      localStorage.setItem(
        localStorageAuthTokenExpiry,
        expiryDate.toISOString()
      );
      break;
    case UNAUTH_USER:
      localStorage.removeItem(localStorageAuthToken);
      localStorage.removeItem(localStorageIsChild);
      localStorage.removeItem(localStorageProfileName);
      localStorage.removeItem(localStorageProfileId);
      localStorage.removeItem(localStorageAuthTokenExpiry);
      localStorage.removeItem(LS_EMAIL);
      // New analytics session on sign out, so anonymous activity that follows is
      // not attributed to the account that just signed out.
      resetSessionID();
      break;
    case USER_DATA_SUCCESS:
      let email = store.getState().userData.new_email;
      if (localStorage.getItem(LS_EMAIL) !== email) {
        localStorage.setItem(LS_EMAIL, email);
      }
      break;
    default:
      break;
  }
  return result;
};
export default persist;
